import { Comments } from '../../constants/apis';
import type { CommentChild, CommentParent, FeedbackShare } from '../../types/feedbacks';
import { ApiManager } from '../axios-config';

export const createComment = async (
  topicId: CommentChild['topicId'],
  topicType: CommentChild['topicType'],
  content: CommentChild['content'],
  ranges: FeedbackShare['ranges'],
  mentions: FeedbackShare['mentions'],
  token: string,
  topicSlug: string,
  topicTitle: string,
  parentId?: CommentChild['parentId'],
) => {
  return ApiManager.post(
    `${Comments}`,
    {
      topicId,
      topicType,
      content,
      topicSlug,
      topicTitle,
      parentId,
      ranges,
      mentions,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const updateComment = async (
  commentId: CommentParent['id'],
  content: CommentParent['content'],
  ranges: FeedbackShare['ranges'],
  mentions: FeedbackShare['mentions'],
  token: string,
) => {
  return ApiManager.put(
    `${Comments}/${commentId}`,
    {
      content,
      ranges,
      mentions,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const reportComment = async (commentId: string, reason: string, token: string) => {
  return ApiManager.put(
    `${Comments}/${commentId}/report`,
    { reason },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const trashComment = async (commentId: CommentParent['id'], token: string) => {
  return ApiManager.put(
    `${Comments}/trash`,
    { ids: [commentId] },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const likeComment = async (commentId: CommentChild['id'], token: string) => {
  return ApiManager.put(`${Comments}/${commentId}/like`, undefined, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const unlikeComment = async (commentId: CommentChild['id'], token: string) => {
  return ApiManager.delete(`${Comments}/${commentId}/like`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
